
const processKpayImg = (dataArray) => {
  const tran_num_pattern = /\b\d{20}\b/g; //sequences of 20 digits
  const date_pattern = /\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}:\d{2}/; //"MM/DD/YYYY HH:MM:SS" format like 01/15/2023 09:30:45
  const transfer_to_pattern = /To|သို့/  //check the present of To or သို့
  const ph_number_pattern = /\([^)]*\d{4}[^)]*\)/

  let tranNum, date, payeeName, payeePhone;

  try {
    tranNum = dataArray
      .filter(item => item.match(tran_num_pattern))[0]
      .match(/\d+/g)[0]
  } catch (error) {
    tranNum = "-";
  }

  try {
    date = dataArray
      .filter(item => item.match(date_pattern))[0]
      .match(/(\d{2}\/\d{2}\/\d{4})/)[1];
    date = formatToTimestamp(true, date);

  } catch (error) {
    date = "";
  }

  try {
    const transferToText = dataArray
      .filter(item => item.match(transfer_to_pattern))[0];

    if (transferToText) {
      if (transferToText.match(/To/)) { // if there is To, it is eng lang
        if (transferToText.includes("(")) {
          payeeName = transferToText
            .match(/To\s+(.*?)\s*\(/)[1] // catch character between To and (
        } else {
          payeeName = transferToText.match(/To\s(.*)/)[1] // catch characters behind To
            .trim();
        }
      } else {
        payeeName = transferToText.match(/သို့\s(.*)/)[1] //catch characters behind သို့
          .trim();
      }
    } else {
      payeeName = dataArray
        .filter(item => item.match(/^[a-zA-Z\s]*$/)
        )
        .filter(item => !item.toLowerCase().includes("transfer"))[0]
        .trim();
    }

  } catch (error) {
    payeeName = ""
  }

  try {
    payeePhone = dataArray
      .filter(item => item.match(ph_number_pattern))[0]
      .match(/\d{4}/)[0];
    payeePhone = `*******${payeePhone}`;

  } catch (error) {
    payeePhone = ""
  }

  return {
    tranNum,
    date,
    payeeName,
    payeePhone,
  }
}

const processWaveImg = (dataArray) => {
  const tran_num_pattern = /\b\d{8,10}\b/g; //sequent 8 or 10 digits
  const primary_date_pattern = /\b\d{2}\s(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{4}\b/; //"dd Mon yyyy" format like 28 Mar 2024
  const secondary_date_pattern = /\b(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s\d{2},\s\d{4}\b/
  const ph_number_pattern = /^0(1|9)\d{7,9}$/
  const name_pattern = /^[A-Za-z\s]+$/

  let tranNum, date, payeeName, payeePhone;

  try {
    let matchArray = dataArray
      .filter(item => item.match(tran_num_pattern))
    let selectedString = matchArray.length > 1 ? matchArray[1] : matchArray[0]
    tranNum = selectedString.match(/\d+/g)[0];
  } catch (error) {
    tranNum = "-";
  }

  try {
    date = dataArray
      .filter(item => item.match(primary_date_pattern))[0]
      .match(primary_date_pattern)[0];
    date = formatToTimestamp(false, date);
  } catch (error) {
    try {
      date = dataArray
        .filter(item => item.match(secondary_date_pattern))[0]
        .match(secondary_date_pattern)[0];
      date = formatToTimestamp(false, date);
    } catch (error) {
      date = "";
    }
  }

  try {
    payeePhone = dataArray
      .filter(item => item.match(ph_number_pattern))[0]
      .match(ph_number_pattern)[0];
  } catch (error) {
    payeePhone = "";
  }

  try {
    payeeName = dataArray
      .filter(item => item.match(name_pattern))[1];
  } catch (error) {
    payeeName = "";
  }

  return {
    tranNum,
    date,
    payeeName,
    payeePhone,
  }
}

function getPaymentType(stringArray) {

  const kpay_tran_num_pattern = /\b\d{20}\b/g; //sequences of 20 digits
  let tranNum = stringArray
    .filter(item => item.match(kpay_tran_num_pattern))[0]
  if (tranNum) {
    return "K Pay"
  } else {
    return "Wave Pay";
  }
}

const formatToTimestamp = (isKpay, dateString) => {
  let unixTimestamp;

  if (isKpay) {
    let dateParts = dateString.split("/");
    let dateObject = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
    unixTimestamp = dateObject.getTime();
  } else {
    unixTimestamp = Date.parse(dateString);
  }

  return unixTimestamp / 1000;
}

export {
  processWaveImg,
  processKpayImg,
  getPaymentType,
  formatToTimestamp,
}